import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import { getAppLocale } from '../content/appLocale';

export default function AccountNavigation() {
  const { locale } = useLocale();
  const { profileMenu } = getAppLocale(locale);
  return <nav className="studio-account-navigation" aria-label="Account">
    <NavLink to="/settings">{profileMenu.accountSettings}</NavLink>
    <NavLink to="/billing">{profileMenu.creditsAndPlans}</NavLink>
  </nav>;
}
